import styled from 'styled-components';

const COLORS = {
  primary: '#2186f6',
  danger: '#f62f21',
};
export const StyledActionButton = styled.button`
  border: none;
  height: 31px;
  width: 120px;
  outline: none !important;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.14);
  background-color: #fbfbfb;
  color: ${(props: any) => (props?.variant ? COLORS[props?.variant] : COLORS.primary)};
  font-size: 16px;
  &:hover {
    background-color: #e0e0e0;
  }
`;

export const StyledAbutton = styled.a`
  border: none;
  height: 31px;
  width: 120px;
  text-align: center;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.14);
  background-color: #fbfbfb;
  color: ${(props: any) => (props?.variant ? COLORS[props?.variant] : COLORS.primary)};
  font-size: 16px;
  border-radius: 0px;
  outline: none !important;
  padding-top: 5px;
  &:hover {
    background-color: #e0e0e0;
  }
`;
